// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCheckmarkCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16 11V8.164l-5 5-3-3V13l3 3z" />,
    <path fillRule="evenodd" d="M12 3a9 9 0 100 18 9 9 0 000-18m-7 9a7 7 0 1114 0 7 7 0 01-14 0" />
  );
export default SvgIconCheckmarkCircle;
